import styled from 'styled-components'
import Section, { SectionContainer, SectionHeader } from '../common/Section'

const TrailerContainer = styled.div`
  max-width: 1000px;
  margin: 0 auto;
`

const VideoWrapper = styled.div`
  position: relative;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  height: 0;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  box-shadow: ${({ theme }) => theme.shadows['2xl']};
  background: ${({ theme }) => theme.colors.backgroundLighter};

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }
`

const TrailerInfo = styled.div`
  text-align: center;
  margin-top: ${({ theme }) => theme.spacing.xl};

  .title {
    font-size: ${({ theme }) => theme.fonts.sizes['2xl']};
    font-weight: 600;
    color: ${({ theme }) => theme.colors.text};
    margin-bottom: ${({ theme }) => theme.spacing.sm};
  }

  .description {
    color: ${({ theme }) => theme.colors.textSecondary};
    max-width: 600px;
    margin: 0 auto;
  }
`

const TrailerStats = styled.div`
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.xl};
  margin-top: ${({ theme }) => theme.spacing.xl};
  flex-wrap: wrap;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
    align-items: center;
  }
`

const Stat = styled.div`
  text-align: center;

  .value {
    font-size: ${({ theme }) => theme.fonts.sizes['3xl']};
    font-weight: 700;
    color: ${({ theme }) => theme.colors.primary};
  }

  .label {
    font-size: ${({ theme }) => theme.fonts.sizes.sm};
    color: ${({ theme }) => theme.colors.textMuted};
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-top: ${({ theme }) => theme.spacing.xs};
  }
`

const Trailer = () => {
  return (
    <Section id="trailer">
      <SectionContainer>
        <SectionHeader>
          <h2>Official Trailer</h2>
          <p>Get a glimpse of the epic adventure that awaits you</p>
        </SectionHeader>

        <TrailerContainer>
          <VideoWrapper>
            <iframe
              title="Nexus Realms Official Trailer"
              src="https://www.youtube.com/embed/dQw4w9WgXcQ?rel=0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </VideoWrapper>

          <TrailerInfo>
            <h3 className="title">Nexus Realms: Official Launch Trailer</h3>
            <p className="description">
              Experience the cinematic journey through the realms. Discover the
              secrets, meet the characters, and prepare for your adventure.
            </p>
          </TrailerInfo>

          <TrailerStats>
            <Stat>
              <div className="value">2.5M+</div>
              <div className="label">Views</div>
            </Stat>
            <Stat>
              <div className="value">98%</div>
              <div className="label">Positive Rating</div>
            </Stat>
            <Stat>
              <div className="value">50K+</div>
              <div className="label">Comments</div>
            </Stat>
          </TrailerStats>
        </TrailerContainer>
      </SectionContainer>
    </Section>
  )
}

export default Trailer
